const REVIEW_EXPANDER_SELECTOR = '.js_pdp_cr-item__expander';

/**
 *
 *
 *
 *
 */
export class SheetReviewExpanderResetter {
    private currentReviewId?: string;

    /**
 *
 *
 *
 *
 *
 */
    public handleReviewShown(reviewId: string, reviewElements: HTMLElement[]): void {
        if (reviewId === this.currentReviewId) return;

        this.collapseExpander(reviewId, reviewElements);
        this.currentReviewId = reviewId;
    }

    /**
 *
 *
 */
    public reset(reviewElements: HTMLElement[]): void {
        this.collapseExpander(this.currentReviewId, reviewElements);
        this.currentReviewId = undefined;
    }

    private collapseExpander(reviewId: string | undefined, reviewElements: HTMLElement[]): void {
        if (!reviewId) return;

        const reviewElement = reviewElements.find(element => element.dataset.reviewId === reviewId);
        const expanderElement = reviewElement?.querySelector<HTMLOcExpanderV1Element>(REVIEW_EXPANDER_SELECTOR);
        if (expanderElement) expanderElement.expanded = false;
    }
}
